module.exports = __webpack_public_path__ + "img/2019.3fbfff9c.png";